import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=f740acae&scoped=true"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=f740acae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f740acae",
  null
  
)

export default component.exports